import { Component, OnInit, Input, Output, ChangeDetectionStrategy } from "@angular/core";
import { Router } from "@angular/router";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { SellerContract } from "../../entity/SellerContract";
import { AuthService } from "../../service/auth.service";
import { GeneralService } from "../../service/general.service";
import { FormsModule } from "@angular/forms";

@Component({
    selector: "accept-buy-order-dialog",
    templateUrl: "../../../html/incs/accept-buy-order-dialog.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule]
})
export class AcceptBuyOfferDialog implements OnInit {
    sellerContracts: SellerContract[] = [];
    sellerContract: SellerContract = null!;
    public confirmMessage:string = null!;

    constructor(public dialogRef: MatDialogRef<AcceptBuyOfferDialog>,
        private router: Router,
        private authService: AuthService,
        private generalService: GeneralService
    ) {}

    ngOnInit(): void {
        if (!this.authService.isLoggedIn()) {
            this.router.navigate(["/user/login"], { queryParams: { redirect: this.router.url } });
        }

        this.generalService.getSellerContracts()
          .then(cs => {
              if (cs!=null) {
                 this.sellerContracts = cs;
              }
           });
    }

    confirm() {
      this.dialogRef.close(this.sellerContract);
    }

    closeDialog() {
      this.dialogRef.close(null!);
    }
}